import apiProfil from '@/api/vo-general/profil';

const defaultState = () => ({
	myProfile: {},
	myBank: {},
	mitraData: null,
	responSukses: {},
	errorValidation: []
});

const state = defaultState();

const getters = {

};

const mutations = {

	setProfile(state, data) {
		state.myProfile = data;
	},
	setBank(state, data) {
		state.myBank = data.data;
	},
	setMitraData(state, data) {
		state.mitraData = data.data;
	},
	setErrorValidation(state, data) {
		state.errorValidation = data
	},
	clearErrorValidation(state) {
		state.errorValidation = []
	},
	clearDataUser(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {

	getProfileMitra({ commit }, params) {
		return new Promise((resolve, reject) => {
			apiProfil.getProfileMitra(params).then((results) => {
				const data = results.data
				// if ( data.status == 200 ) {
					commit('setProfile', data.data.results);
					resolve(data)
				// } else {
				// 	dispatch("errorHandler", data)
				// 	reject()
				// }
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data mitra tidak dapat ditampilkan.'
				}, { root: true });
				commit('setProfile', { data: {} });
				reject()
			});
		});
	},
	editProfileMitra({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			apiProfil.editProfileMitra(value).then((res) => {
				const data = res.data;
				// if ( data.status == 200 ) {
					const authData = data.data.results
					// let token = authData.token
					let memberData = authData
					// memberData['token'] = token
					commit('autentikasi/setProfileData', memberData , { root: true });
					dispatch('success', data)
					resolve()
				// } else {
				// 	dispatch('errorHandler', data)
				// 	reject()
				// }
			})
			.catch((err) => {
				let {data} = err.response
				reject(true)
				dispatch('errorHandler', data)
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Perubahan data mitra tidak dapat diproses!'
				}, { root: true });
				reject()
			});
		});
	},
	changeImageMitra({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			apiProfil.changeImageMitra(value).then((res) => {
				const data = res.data;
				const image = data.data.results.member_image_url;
				// if ( data.status == 200 ) {
					commit('autentikasi/updateImage', image , { root: true });
					dispatch('success', data)
					resolve()
				// } else {
				// 	dispatch("errorHandler", data)
				// }
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Perubahan gambar profil mitra tidak dapat diproses!'
				}, { root: true });
				reject()
			});
		});
	},
	changePasswordMitra({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			apiProfil.changePasswordMitra(value).then((results) => {
				const data = results.data;
				// if ( data.status == 200 ) {
					dispatch('success', data)
					resolve()
				// } else {
				// 	dispatch("errorHandler", data)
				// 	reject()
				// }
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Perubahan password akun mitra tidak dapat diproses!'
				}, { root: true });
				reject()
			});
		});
	},

	async getMitraData({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiProfil.getMitraData(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setMitraData', data.results);
					resolve(data)
				} else {
					resolve(data)
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setMitraData', []);
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error) {
				case 'validation':
					commit('setErrorValidation', response.data)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};